export var lightTheme = {
    // Colors
    background: '#ffffff',
    text: '#1f2937',
    textSecondary: '#4b5563',
    textMuted: '#9ca3af',
    border: '#e5e7eb',
    borderLight: '#f3f4f6',
    paper: '#ffffff',
    paperLight: '#f9fafb',
    paperHover: '#f3f4f6',
    paperActive: '#e5e7eb',
    paperDark: '#f3f4f6',
    primary: '#3b82f6',
    primaryDark: '#2563eb',
    primaryLight: '#60a5fa',
    primaryText: '#ffffff',
    secondary: '#8b5cf6',
    secondaryDark: '#7c3aed',
    secondaryLight: '#a78bfa',
    secondaryText: '#ffffff',
    shadow: 'rgba(0, 0, 0, 0.1)',
    // Alert colors
    info: '#3b82f6',
    infoLight: '#dbeafe',
    success: '#10b981',
    successLight: '#d1fae5',
    warning: '#f59e0b',
    warningLight: '#fef3c7',
    error: '#ef4444',
    errorLight: '#fee2e2',
    // Typography
    typography: {
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        fontSize: {
            xs: '12px',
            sm: '14px',
            base: '16px',
            lg: '18px',
            xl: '20px',
            xxl: '24px'
        },
        fontWeight: {
            normal: 400,
            medium: 500,
            semibold: 600,
            bold: 700
        }
    },
    // Spacing
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px'
    },
    // Border radius
    radius: {
        sm: '0.25rem',
        md: '0.375rem',
        lg: '0.5rem',
        xl: '0.75rem',
        full: '9999px'
    },
    // Transitions
    transition: {
        fast: '150ms ease-in-out',
        normal: '300ms ease-in-out',
        slow: '450ms ease-in-out'
    },
    // Breakpoints
    breakpoints: {
        xs: '480px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px'
    },
    // Theme state
    isDark: false,
    // Additional colors for specific components
    tooltipBg: '#1f2937',
    tooltipText: '#ffffff'
};
